/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import { NavLink } from "react-router-dom";

import MenuRoute from "./menu.route";

const MenuConsended = ({ fluid }) => {
  const History = useHistory();
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  return (
    <div className="navbar-collapse collapse" id="navbar-menu">
      <div className="container w-75">
        <ul className="navbar-nav d-flex justify-content-between">
          {MenuRoute.map((menu, index) => {
            return (
              <li key={index} className="nav-item">
                {!menu?.isDropdown ? (
                  <NavLink
                    to={menu.path}
                    className="nav-link"
                    activeClassName="active"
                    isActive={(match, location) => {
                      const splitLocation = location.pathname.split("/");

                      if (splitLocation[1] === menu.isActive) {
                        return true;
                      }

                      if (
                        menu.isActive === "booking" &&
                        splitLocation[1] === "down-payment"
                      ) {
                        return true;
                      }

                      if (
                        menu.isActive === "pricing" &&
                        splitLocation[1] === "vehicle"
                      ) {
                        return true;
                      }
                    }}
                  >
                    <span className="nav-link-title">{menu?.title}</span>
                  </NavLink>
                ) : (
                  <Nav>
                    <NavDropdown
                      id="nav-dropdown-dark-example"
                      title={
                        <span className="nav-link-title">{menu?.title}</span>
                      }
                    >
                      {menu?.child.map((c, index) => {
                        return (
                          <NavDropdown.Item
                            key={index}
                            onClick={() => History.push(c?.path)}
                            active={splitLocation[1] === c?.isActive}
                          >
                            {c?.title}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                  </Nav>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MenuConsended;
